import { memo } from 'react';
import { Box, Text } from '@betty/moonlight';
import { DailyGift, selectDailyGiftStatus } from '@betty/daily-gift';
import { useSelector } from '@betty/toolkit/state';
import { isUserOnBreak } from '@betty/account';

function DailyGiftSection() {
  const isUserTimedOut = useSelector(isUserOnBreak);
  const dailyGiftStatus = useSelector(selectDailyGiftStatus);

  if (isUserTimedOut || dailyGiftStatus === 'NotAvailable') return null;

  return (
    <Box
      flex={1}
      marginTop="space-400"
      paddingHorizontal="space-400"
      gap="space-200"
    >
      <Text
        variant="h6"
        locNS="rewards"
        locKey="yourDailyGift"
        gradient="darkSurfaceAccent"
      />
      <Box
        variant="gradient"
        gradient="accentBackground"
        padding="space-800"
        borderRadius="radius-200"
        flex={1}
      >
        <DailyGift />
      </Box>
    </Box>
  );
}

export default memo(DailyGiftSection);
